import {useEffect, useState} from 'react'
import {CDRFilter} from './CDRFilter'
import {CDRSettingsModal} from './CDRSettingsModal'
import {CDRSearchComponent} from './CDRSearchComponent'
import {usersAPI} from '../../../services/UsersService'
import ToggleButton from 'react-bootstrap/esm/ToggleButton'
import {DateRangePickerInput} from '../helpers/DateRangePicker'
import {updateQuery, setQuery} from '../slices/cdrFilterSlice'
import {useAppDispatch, useAppSelector} from '../../../hooks/redux'
import ToggleButtonGroup from 'react-bootstrap/esm/ToggleButtonGroup'
import {shallowEqual} from 'react-redux'
import {Link, useLocation, useParams} from 'react-router-dom'
import {KTSVG} from '../../../template/helpers'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'
import {ModalPromt} from './ai/ModalPromt'
import {useAccount} from '../../../hooks/useAccount'

type IToggleButtonValue = 'ALL' | 'INBOUND' | 'OUTBOUND' | 'MISSED'

const CDRHeader = () => {
  const {appId} = useParams()
  const location = useLocation()
  const dispatch = useAppDispatch()
  const {data: currentUser} = usersAPI.useFetchGetMeQuery()
  const {isAgent} = useAccount()
  const query = useAppSelector((state) => state.cdrFilter.query, shallowEqual)
  const [showSettings, setShowSettings] = useState<boolean>(false)
  const [showPromtSettings, setShowPromtSettings] = useState<boolean>(false)
  const [toggleButtonValue, setToggleButtonValue] = useState<IToggleButtonValue>('ALL')
  const [linkCSR] = useState<string>(location.pathname.includes('/management') ? '/management/csr' : '/csr')

  useEffect(() => {
    if (query) {
      if (!query.direction && !query.status) {
        setToggleButtonValue('ALL')
      } else if (query.status === 'NO_ANSWER' && query.direction === 'INBOUND') {
        setToggleButtonValue('MISSED')
      } else if (query.direction === 'INBOUND') {
        setToggleButtonValue('INBOUND')
      } else if (query.direction === 'OUTBOUND') {
        setToggleButtonValue('OUTBOUND')
      }
    }
  }, [query])

  const handleShowModalSettings = () => {
    setShowSettings(true)
  }
  const handleHideModalSettings = () => {
    setShowSettings(false)
  }

  const handleShowPromtSettings = () => {
    setShowPromtSettings(true)
  }
  const handleHidePromtSettings = () => {
    setShowPromtSettings(false)
  }

  return (
    <div className='card-header border-1'>
      <div className='d-flex flex-stack mt-2 col-12 align-items-center'>
        <div className='w-290px'>
          <DateRangePickerInput
            language={currentUser?.language}
            timeZone={currentUser?.time_zone}
            rangeId='1'
            onlyIcon={false}
          />
        </div>
        <CDRFilter />
        <div>
          <ToggleButtonGroup
            type='radio'
            name='options'
            defaultValue={'ALL'}
            onChange={(val) => {
              setToggleButtonValue(val)
            }}
          >
            <ToggleButton
              id='tbg-radio-1'
              value={'ALL'}
              variant={toggleButtonValue === 'ALL' ? 'primary' : 'outline-primary'}
              size='sm'
              onClick={() => {
                const {status, direction, ...rest} = query || {}
                dispatch(setQuery({...rest, offset: 0}))
              }}
            >
              Все
            </ToggleButton>
            <ToggleButton
              id='tbg-radio-2'
              value={'INBOUND'}
              variant={toggleButtonValue === 'INBOUND' ? 'primary' : 'outline-primary'}
              size='sm'
              onClick={() => {
                const {status, ...rest} = query || {}
                dispatch(setQuery({...rest, direction: 'INBOUND', offset: 0}))
              }}
            >
              <i className='bi bi-arrow-down-right-circle fs-3' /> Входящие
            </ToggleButton>
            <ToggleButton
              id='tbg-radio-3'
              value={'OUTBOUND'}
              variant={toggleButtonValue === 'OUTBOUND' ? 'primary' : 'outline-primary'}
              size='sm'
              onClick={() => {
                const {status, ...rest} = query || {}
                dispatch(setQuery({...rest, direction: 'OUTBOUND', offset: 0}))
              }}
            >
              <i className='bi bi-arrow-up-left-circle fs-3' />
              Исходящие
            </ToggleButton>
            <ToggleButton
              id='tbg-radio-4'
              value={'MISSED'}
              variant={toggleButtonValue === 'MISSED' ? 'primary' : 'outline-primary'}
              size='sm'
              onClick={() => {
                dispatch(updateQuery({...query, direction: 'INBOUND', status: 'NO_ANSWER', offset: 0}))
              }}
              disabled={isAgent}
            >
              <i className='bi bi-x-circle fs-3' />
              Пропущенные
            </ToggleButton>
          </ToggleButtonGroup>
        </div>
        <div className='d-flex align-items-center gap-1'>
          <CDRSearchComponent />
          {!isAgent && (
            <>
              <div className='ms-1 d-flex align-items-center'>
                <button className='btn btn-sm p-0' onClick={handleShowModalSettings}>
                  <i className='bi bi-gear text-hover-gray-600 fs-3 text-primary' />
                </button>
              </div>
              <CDRSettingsModal show={showSettings} handleClose={handleHideModalSettings} />
              <i className='bi bi-filetype-ai cursor-pointer fs-4 text-info' onClick={handleShowPromtSettings} />
              <ModalPromt app_id={appId!} show={showPromtSettings} handleClose={handleHidePromtSettings} />
            </>
          )}
          <OverlayTrigger
            delay={{show: 50, hide: 50}}
            overlay={
              <Tooltip id='tooltip-title' style={{position: 'fixed'}}>
                Перейти к отчётам
              </Tooltip>
            }
          >
            <Link to={`${linkCSR}/${appId}`}>
              <span className='badge badge-light-success cursor-pointer'>
                <KTSVG path='/media/icons/duotune/graphs/gra001.svg' className='svg-icon-success' />
              </span>
            </Link>
          </OverlayTrigger>
        </div>
      </div>
    </div>
  )
}

export {CDRHeader}
